/* eslint-disable import/no-unassigned-import */
import {
  DatePicker as DatePickerBase,
  type DatePickerProps,
  type DatePickerType,
} from '@mantine/dates';
import '@mantine/dates/styles.css';
import React from 'react';

export const DatePicker = <Type extends DatePickerType = 'default'>(
  props: DatePickerProps<Type>,
) => <DatePickerBase {...props} />;
